import type { RecommendationFeedbackMutation, RecommendationFeedbackScope, RecommendationChoiceContext } from "@batch-and-bowl/validators";
import { RECOMMENDATION_ATTRIBUTION_CAPABILITY } from "@batch-and-bowl/shared";
import { apiFetch } from "./client";

export interface RecommendationSuppression {
  recipeId: string;
  scope: RecommendationFeedbackScope;
  revisionId: string;
  createdAt: string;
  updatedAt: string;
  recipe: { id: string; title: string } | null;
}

export function getRecommendationSuppressions(actorUserId: string, signal?: AbortSignal) {
  return apiFetch<RecommendationSuppression[]>("/users/recommendation-feedback", {
    signal, headers: { "X-Expected-User-Id": actorUserId },
  });
}

export function changeRecommendationFeedback(actorUserId: string, input: RecommendationFeedbackMutation, context?: RecommendationChoiceContext) {
  return apiFetch<{ replayed: boolean; suppressions: RecommendationSuppression[] }>("/users/recommendation-feedback", {
    method: "PUT", headers: { "X-Expected-User-Id": actorUserId,
      ...(context ? { "X-Recommendation-Capability": RECOMMENDATION_ATTRIBUTION_CAPABILITY, "X-Recommendation-Choice": JSON.stringify(context) } : {}),
    }, body: JSON.stringify(input),
  });
}
